import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconCylinders: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path d="M13 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM12 18.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" />
    <path
      fillRule="evenodd"
      d="M10 1.9a2.6 2.6 0 0 0-2.6 2.6v5.173c0 1.323 1.623 1.936 2.5.981v2.706c0 .278-.095.548-.269.765l-.87 1.088a3.931 3.931 0 0 0-.785 1.687H6v1.2h1.923a3.932 3.932 0 0 0 3.908 3.5h.338a3.932 3.932 0 0 0 3.907-3.5H18v-1.2h-1.976a3.93 3.93 0 0 0-.786-1.687l-.87-1.088a1.225 1.225 0 0 1-.268-.765v-2.706c.877.955 2.5.342 2.5-.98V4.5A2.6 2.6 0 0 0 14 1.9h-4ZM8.6 4.5A1.4 1.4 0 0 1 10 3.1h4a1.4 1.4 0 0 1 1.4 1.4v5.173c0 .227-.284.33-.429.155l-.05-.06a3.803 3.803 0 0 0-5.842 0l-.05.06a.242.242 0 0 1-.43-.155V4.5Zm4.3 5.26a2.601 2.601 0 0 0-1.8 0v3.6c0 .55-.188 1.085-.532 1.515l-.87 1.087a2.731 2.731 0 0 0 2.133 4.438h.338a2.731 2.731 0 0 0 2.132-4.438l-.87-1.087a2.425 2.425 0 0 1-.531-1.515v-3.6Z"
      clipRule="evenodd"
    />
  </Icon>
);
